import {CelluleTableauDTO} from "../../dtos/gestionmenus/planning/cellule-tableau-dto";
import {MenuCompositionDTO} from "../../dtos/menucomposition-dto";

export class InfosMenuCompoSupplier {
  cellule: CelluleTableauDTO;
  menuCompo: MenuCompositionDTO;
}
